import { Icon, BadgeZinc } from "@sellar-io/components";
import { Tooltip } from "@sellar-io/components";
import { TooltipTrigger } from "@sellar-io/components";
import { TooltipContent } from "@sellar-io/components";
import { useNavigate } from "react-router";
import { PRODUCT_LIST_CATEGORY } from "../../constants/routes";

const InactiveBadgeToolTipContent = ({ productId }: { productId: number }) => {
  const navigate = useNavigate();
  return (
    <div
      className={
        "max-w-[300px] rounded-xl border border-zinc-300 bg-white px-4 py-3"
      }
    >
      <div className="flex items-center gap-2 bg-white">
        <Icon icon="INFORMATION_OUTLINE" className="flex-none text-zinc-800" />
        <div>
          <div className="text-sm font-semibold text-zinc-800">
            Inactive product
          </div>
          <div className="text-xs text-zinc-700">
            Inactive products can't been seen by customers regardless of their
            settings. Go to your product list to edit this
          </div>
          <span
            className="group inline-flex cursor-pointer items-center gap-2 rounded-lg py-2 text-xs font-semibold uppercase"
            onClick={() => navigate(PRODUCT_LIST_CATEGORY.href({ productId }))}
          >
            <span className="group-hover:underline">Go to product</span>
            <Icon icon="CHEVRON_RIGHT" />
          </span>
        </div>
      </div>

      {/* Tooltip tail */}
      <div className="absolute bottom-[-5px] left-1/2 -translate-x-1/2">
        <div className="h-3 w-3 -rotate-135 transform border-t border-l border-gray-300 bg-white"></div>
      </div>
    </div>
  );
};

export const InactiveBadge = ({ productId }: { productId: number }) => {
  return (
    <Tooltip placement="top">
      <TooltipTrigger className="w-fit">
        <BadgeZinc className="bg-zinc-200">Inactive</BadgeZinc>
      </TooltipTrigger>
      <TooltipContent>
        <InactiveBadgeToolTipContent productId={productId} />
      </TooltipContent>
    </Tooltip>
  );
};
